import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const CheckCircleIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { fill: "none", viewBox: "0 0 18 18", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("path", { stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M14.703 3.755a7.722 7.722 0 0 1 2.163 5.368 7.742 7.742 0 1 1-5.78-7.49" }),
        React.createElement("path", { stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "m5.408 9.453 2.892 2.66 7.397-9.657" })));
};
export default CheckCircleIcon;
//# sourceMappingURL=index.js.map